import {setHash} from "@/utils/utils"

export default {
	setBodyOverflowHidden: (state, bool) => {
		state.bodyOverflowHidden = bool;
	},

	setDatepickerOpen: (state, str) => {
		state.datepickerOpen = str;
	},
	setParticipantsDropdownOpen: (state, bool) => {
		if (!window.participantsDropdownDisabled) {
			state.participantsDropdownOpen = bool;
		}
	},
	setPackagesMobileDropdownOpen: (state, bool) => {
		state.packagesMobileDropdownOpen = bool;
	},

	setProductUnavailable: (state, bool) => {
		state.productUnavailable = bool;
	},

	setParticipants: (state, newArray) => {
		state.participants = newArray;
	},
	setPackage: (state, newPackCode) => {
		state.packCode = newPackCode;
	},
	setPackageId: (state, pacakgeId) => {
		state.packageId = pacakgeId;
	},

	setLoading: (state, bool) => {
		state.loading = bool;
	},

	setErrorMessageOpen: (state, str) => {
		state.errorMessageOpen = str;
	},

	setScrollToPrestationFired: (state, bool) => {
		state.scrollToPrestationFired = bool;
	},

	setCheckedNeedToPreselectPrestations: (state, bool) => {
		state.checkedNeedToPreselectPrestations = bool;
	},

	setQuoteRequestsFinishedLoading: (state, bool) => {
		state.quoteRequestsFinishedLoading = bool;
	},

	setLastQuotesRequestTimestamp: (state, timestamp) => {
		state.lastQuotesRequestTimestamp = timestamp;
	},

	setScreenType: (state, newType) => {
		state.screenType = newType;
	},

	setSeason: (state, newSeason) => {
		state.season = newSeason;
	},
	setTransport: (state, newBool) => {
		state.transportCheckbox = newBool;
	},
	setTransportTrue: (state, newBool) => {
		state.transportCheckbox = newBool;
	},

	setActivePrestations(state, activePrestations) {
        state.activePrestations = activePrestations;
    },

	setPrestationsFromCatalog(state, prestationsFromCatalog) {
        state.prestationsFromCatalog = prestationsFromCatalog;
    },

	setFeeFromWIYP(state, newWiypFee) {
		state.wiypFees = newWiypFee;
	},

	setFlightOrigins(state, flightOrigins) {
		state.flightOrigins = flightOrigins
	},

	setFlightOrigin(state, origin) {
		state.flightOrigin = origin
		setHash({origin})
	},

	setTransportationSelected(state, selected) {
		state.transportationSelected = selected
	},
	updateInitialPrestationsInState(state, newInitialPrestationsArray) {
		state.initialPrestationsArray = newInitialPrestationsArray;
	},
	resetWiypCall(state) {
		state.wiypCall = {};
	},
	setWiypCall(state, { familyComposition, origin, packageCode, packageId, response }) {
		if (!state.wiypCall[familyComposition]) {
			state.wiypCall[familyComposition] = {};
		}
		if (!state.wiypCall[familyComposition][origin]) {
			state.wiypCall[familyComposition][origin] = {};
		}
		if (!state.wiypCall[familyComposition][origin][packageCode]) {
			state.wiypCall[familyComposition][origin][packageCode] = {};
		}
		state.wiypCall[familyComposition][origin][packageCode][packageId] = response;
	},
	updateWiypCallWithAvailability(state, packagePrestMap) {
		// We need to iterate into state.wiypCall and prune wiypPrices elements not present in keysArray.
		const wiypCall = state.wiypCall;
  
		// Iterate over Level 1 (e.g., "18-18")
		for (const famCompKey in wiypCall) {
			const familyComp = wiypCall[famCompKey];
			// Iterate over Level 2 (e.g., "STP")
			for (const originKey in familyComp) {
				const packages = familyComp[originKey];
			 	// Iterate over Level 3 (e.g., "PFP", "NA")
				for (const packageKey in packages) {
					// CHECK: Does Level 3 key exist in the Map?
					if (packagePrestMap.has(packageKey)) {
						const mapRules = packagePrestMap.get(packageKey) || [];
						const prestObjects = packages[packageKey];
						// Iterate over Level 3 (e.g., "868071")
						for (const prestIdKey in prestObjects) {
							// Find rules in the Map that match this specific Level 3 prestId
							const relevantRules = mapRules.filter(r => r.prestId === prestIdKey);
							// If we have rules, we must filter wiypPrices
							if (relevantRules.length > 0) {
								// Create a Set of allowed IDs (Source or Fusion) for O(1) lookup
								const allowedIds = new Set();
								relevantRules.forEach(rule => {
									if (rule.prestIdSource) allowedIds.add(rule.prestIdSource);
									if (rule.prestIdFusion) allowedIds.add(rule.prestIdFusion);
								});					
								// Filter the wiypPrices array
								prestObjects[prestIdKey].wiypPrices = prestObjects[prestIdKey].wiypPrices.filter(price => {
									return allowedIds.has(price.prestId);
								});
							}					
							// CLEANUP LEVEL 3: If wiypPrices is empty, delete the prestId key
							if (prestObjects[prestIdKey].wiypPrices.length === 0) {
								delete prestObjects[prestIdKey];
							}
						}				
						// CLEANUP LEVEL 2: If the package object is empty, delete the package key
						if (Object.keys(prestObjects).length === 0) {
							delete packages[packageKey];
						}
					}
					// CLEANUP LEVEL 1: If the region object is empty, delete the region key
					if (Object.keys(packages).length === 0) {
						delete wiypCall[originKey];
					}
				}
			}
		}
	}
};
